<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 09:42:11
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 15:16:11
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 09:17:50
 * @LastEditors: lau
 * @LastEditTime: 2022-08-19 10:00:57
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "monthId":"",
                "status":""
  
            },
            responseCode: {
                
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据月票id获取月票预约信息",
                t_url: this.commonUrls.test + "getMonthTicketAppointmentLineUp",
                p_url: this.commonUrls.prod + "getMonthTicketAppointmentLineUp",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '状态' },

                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前总数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' },

					   ]
                },
                {
                    titleName: "recordList",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'id', info2: '是', info3: 'Long', info4: '预约记录id' },
                        { info1: 'monthTicketId', info2: '否', info3: 'Long', info4: '月票类型id' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '用户id' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '预约状态' },
                        { info1: 'isDelete', info2: '否', info3: 'Integer', info4: '是否删除 0 未删除 1 已删除' },
                        { info1: 'createTime', info2: '否', info3: 'Date', info4: '创建时间' },
                        { info1: 'updateTime', info2: '否', info3: 'Date', info4: '更新时间' },
                        { info1: 'toppingTime', info2: '否', info3: 'Date', info4: '置顶时间' },
                        { info1: 'canBuyTimeStart', info2: '否', info3: 'Date', info4: '能购买开始时间' },
                        { info1: 'canBuyTimeEnd', info2: '否', info3: 'Date', info4: '能购买结束时间' },
                        { info1: 'billCode', info2: '否', info3: 'String', info4: '订单号' },
                        { info1: 'pushTime', info2: '否', info3: 'Date', info4: '上次推送时间' },
                        { info1: 'pushTotal', info2: '否', info3: 'Integer', info4: '推送次数' },
                        { info1: 'statusMsg', info2: '否', info3: 'String', info4: '' },
                        { info1: 'ticketCertifi', info2: '否', info3: 'JSONObject', info4: '' },
                        { info1: 'isNeedCertifi', info2: '否', info3: 'Integer', info4: '是否需要' },
                        { info1: 'lineUpCount', info2: '否', info3: 'Integer', info4: '' },
                        { info1: 'monthIdName', info2: '否', info3: 'String', info4: '' },

                        { info1: 'parkNameList', info2: '否', info3: 'String', info4: '车场名称列表' },
                        { info1: 'reservedPlaces', info2: '否', info3: 'Integer', info4: '月票车位数' },
                        { info1: 'finParkId', info2: '否', info3: 'Long', info4: '财务主体车场id' },
                        { info1: 'ticketType', info2: '否', info3: 'Integer', info4: '月票类型' },
                        { info1: 'isOpen', info2: '否', info3: 'Integer', info4: '是否开通' },
                        { info1: 'parkName', info2: '否', info3: 'String', info4: '车场名称' },
                        { info1: 'pkGlobalid', info2: '否', info3: 'String', info4: '车场uuid' },


					   ]
                },{
                    titleName: "ticketCertifi",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'monthTicketConfigId', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'ticketName', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'telephone', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'certifiUrl', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'certifiName', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'submitTime', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'parkName', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'status', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'statusStr', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'type', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'typeStr', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'expriedTime', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'reason', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'checkTime', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'checkBy', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'remark1', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'remark2', info2: '否', info3: 'Long', info4: '授权记录id' },
                        { info1: 'remark3', info2: '否', info3: 'Long', info4: '授权记录id' },



					   ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketAppointmentLineUp.vue